import {
  RequiredFeatureProjectLevelName,
  RequiredFeaturesProjectLevel,
} from "@utils/feature-control/project/project-feature-control-types";

/**
 * Object that determines all different feature permission for users to get
 * access on the project level.
 */
export const requiredFeaturesProjectLevel: RequiredFeaturesProjectLevel<RequiredFeatureProjectLevelName> =
  {
    /** Whether the user can archive projects. */
    [RequiredFeatureProjectLevelName.canArchiveProject]: {
      projectSubscriptionRoles: ["project-archive"],
    },

    /** Whether the user can unarchive projects. */
    [RequiredFeatureProjectLevelName.canUnarchiveProject]: {
      projectSubscriptionRoles: ["project-unarchive"],
    },

    /** Whether the user can view 2d image feature. */
    [RequiredFeatureProjectLevelName.canView2dImagesFeature]: {
      projectSubscriptionRoles: ["ft_image_2d"],
    },

    /** Whether the user can view video mode feature. */
    [RequiredFeatureProjectLevelName.canViewVideoModeFeature]: {
      projectSubscriptionRoles: ["global-videomode"],
    },

    /** Whether the user can view face blurring feature. */
    [RequiredFeatureProjectLevelName.canViewFaceBlurringFeature]: {
      projectSubscriptionRoles: ["global-face-blurring"],
    },

    /** Whether the user can view face blurring v1 feature. */
    [RequiredFeatureProjectLevelName.canViewFaceBlurringV1Feature]: {
      projectSubscriptionRoles: ["ft_face_blurring"],
    },

    /** Whether the user can download projects. */
    [RequiredFeatureProjectLevelName.canDownloadProject]: {
      projectSubscriptionRoles: ["project-download"],
    },

    /** Whether the user can manage project integrations. */
    [RequiredFeatureProjectLevelName.canManageProjectIntegrations]: {
      projectSubscriptionRoles: ["dashboard-project-integrations"],
    },
  };
